import { useState } from 'react';

import { meldeAn } from '../daten/abgleich.ts';
import { Passwortfeld } from './Passwortfeld.tsx';

/**
 * Die Anmeldung braucht einmal Verbindung. Danach bleibt die Sitzung 30 Tage
 * auf dem Geraet — sonst stuende der Vertrieb ohne Empfang vor einem
 * Anmeldebildschirm.
 */
export function Anmeldung({ onFertig }: { onFertig: () => void }): React.JSX.Element {
  const [email, setEmail] = useState('');
  const [passwort, setPasswort] = useState('');
  const [fehler, setFehler] = useState<string | null>(null);
  const [laeuft, setLaeuft] = useState(false);

  async function abschicken(ereignis: React.FormEvent): Promise<void> {
    ereignis.preventDefault();
    setLaeuft(true);
    setFehler(null);
    try {
      await meldeAn(email, passwort);
      onFertig();
    } catch {
      setFehler(
        navigator.onLine
          ? 'E-Mail oder Passwort stimmt nicht.'
          : 'Für die erste Anmeldung wird einmal Verbindung gebraucht.',
      );
    } finally {
      setLaeuft(false);
    }
  }

  return (
    <div className="anmeldung-buehne">
      <form className="anmeldung" onSubmit={abschicken}>
        <div className="kopf">
          <div className="zeichen" aria-hidden="true">
            <svg
              width="26"
              height="26"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
            >
              <circle cx="12" cy="12" r="4" />
              <path d="M12 2v2M12 20v2M4.93 4.93l1.41 1.41M17.66 17.66l1.41 1.41M2 12h2M20 12h2M4.93 19.07l1.41-1.41M17.66 6.34l1.41-1.41" />
            </svg>
          </div>
          <p className="wortmarke">
            WANIA <b>PV</b>
          </p>
          <p className="klein" style={{ margin: '0.25rem 0 0' }}>
            Aufnahme, Planung und Angebot
          </p>
        </div>

        <div className="karte-block">
          <div className="feld">
            <label htmlFor="email">E-Mail</label>
            <input
              id="email"
              type="email"
              autoComplete="username"
              value={email}
              onChange={(ereignis) => setEmail(ereignis.target.value)}
              required
            />
          </div>

          <div className="feld">
            <label htmlFor="passwort">Passwort</label>
            <Passwortfeld
              id="passwort"
              autoComplete="current-password"
              value={passwort}
              onChange={(ereignis) => setPasswort(ereignis.target.value)}
              required
            />
          </div>

          {fehler && <div className="hinweis hinweis--fehler">{fehler}</div>}

          <button className="wichtig" type="submit" disabled={laeuft}>
            {laeuft ? 'Einen Moment …' : 'Anmelden'}
          </button>
        </div>
      </form>
    </div>
  );
}
